import { render, staticRenderFns } from "./SectionCheckReminder.vue?vue&type=template&id=ef6e81f6&scoped=true"
import script from "./SectionCheckReminder.vue?vue&type=script&lang=js"
export * from "./SectionCheckReminder.vue?vue&type=script&lang=js"
import style0 from "./SectionCheckReminder.vue?vue&type=style&index=0&id=ef6e81f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6e81f6",
  null
  
)

export default component.exports